import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useCurrentAccountId } from '@zapier/identity';
import { UNIVERSAL_NAV_ZINDEX, UniversalFooter, UniversalNav, UniversalNavProvider, useUniversalNavContext, } from '@zapier/universal-layout';
import { AlertBanner } from '../AlertBanner';
const Styles = {
    root: css `
    display: block;
  `,
    alertBanner: css `
    &:empty {
      display: none;
    }
  `,
    grid: css `
    min-height: 100vh;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'head'
      'main'
      'foot';
    gap: 0;
    transition: all ease-in-out 300ms;
  `,
    gridWithSidebar: (sidebarWidth) => css `
    grid-template-columns: ${sidebarWidth}px 1fr;
    grid-template-areas:
      'head head'
      '.... main'
      '.... foot';
  `,
    head: (topbarHeight) => css `
    grid-area: head;
    // Stickiness is handled by UniversalNav but needs
    // to be reinforced here to work properly.
    position: sticky;
    z-index: ${UNIVERSAL_NAV_ZINDEX};
    top: -${topbarHeight}px;
  `,
    main: css `
    grid-area: main;
    position: relative;
  `,
    foot: css `
    grid-area: foot;
  `,
};
const defaultProps = {
    mainContentId: 'mainContent',
    renderAlertBanner: (props) => (isolateComponent(AlertBanner, { trackEvent: props.trackEvent, useMutation: props.useMutation, useQuery: props.useQuery })),
    renderNotifications: () => null,
    renderHeader: (props) => {
        return (isolateComponent(UniversalNav, { renderNotifications: props.renderNotifications, skipLinkHref: `#${props.mainContentId}` }));
    },
    renderFooter: (props) => {
        return (isolateComponent(UniversalFooter, { shouldRenderAlphabetNav: props.shouldRenderAlphabetNav, shouldRenderSeoLinks: props.shouldRenderSeoLinks, showSimplifiedFooter: props.showSimplifiedFooter }));
    },
};
const UniversalLayoutInner = (props) => {
    const { sidebarWidth, topbarHeight } = useUniversalNavContext();
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: Styles.alertBanner, "data-testid": "UniversalLayoutAlertBanner" }, props.renderAlertBanner(props)),
        isolateComponent("div", { css: [
                Styles.grid,
                sidebarWidth && Styles.gridWithSidebar(sidebarWidth),
            ] },
            isolateComponent("div", { css: Styles.head(topbarHeight) }, props.renderHeader(props)),
            isolateComponent("main", { css: Styles.main, id: props.mainContentId }, props.children),
            isolateComponent("div", { css: Styles.foot }, props.renderFooter(props)))));
};
export const UniversalLayout = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const currentAccountId = useCurrentAccountId();
    return (isolateComponent(UniversalNavProvider, { currentAccountId: currentAccountId, currentUrl: props.currentUrl, useQuery: props.useQuery },
        isolateComponent(UniversalLayoutInner, Object.assign({}, props))));
};
UniversalLayout.defaultProps = defaultProps;
//# sourceMappingURL=UniversalLayout.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
